<template>
<div class="wrap" :class="{show: showWrap}" >
    <div class="bg"></div>
    <main-pc class="pc" :showContent="showContent" :success="success" :close="closeHandle" :logout="logout" :thirdHost="thirdHost" :oldThirdHost="oldThirdHost" :clientId="clientId" />
    <main-m class="m" :showContent="showContent" :success="success" :close="closeHandle" :logout="logout" :thirdHost="thirdHost" :oldThirdHost="oldThirdHost" :clientId="clientId" />
</div>
</template>
<script>

import main from './main';
import mMain from './mMain';
import logreg from './js/logreg';
import api from './js/api';

// eslint-disable-next-line no-mixed-operators
const getRegV = (key) => window.baseAxios && window.baseAxios.loginReg && window.baseAxios.loginReg[key] || '';

export default {
    name: 'wrap',
    props: {
        baseUrl: { type: String, default: () => getRegV('baseUrl') },
        thirdHost: { type: String, default: () => getRegV('thirdHost') },
        oldThirdHost: { type: String, default: () => getRegV('oldThirdHost') },
        clientId: { type: String, default: () => getRegV('clientId') },
        client_secret: { type: String, default: () => getRegV('client_secret') },
        business: { type: String, default: () => getRegV('business') },
        redirect_uri: { type: String, default: () => getRegV('redirect_uri') },
        alias: { type: String, default: () => getRegV('alias') },
        logout: { type: Function, default: () => {} },
        success: { type: Function, default: () => {} },
        fail: { type: Function, default: () => {} },
        // code.vue 人机验证多语言
        codePlaceholder:{
     type:String,default:'userSign.inputCode'
    }
    },
    provide () {
    return {
      inputCodePlaceholder: this.codePlaceholder
    }
  },
    components: {
        'main-pc': main,
        'main-m': mMain
    },
    data() {
        return {
            showWrap: false,
            showState: false,
            showContent: false
        };
    },
    methods: {
        closeHandle() {
            this.closeFrame();
        },
        showFrame() {
            this.showState = true;
        },
        closeFrame() {
            this.showState = false;
        },
        logoutAction() {
            logreg.logoutAction(this.logout);
        },
        isLogined() {
            return logreg.isLogined();
        },
        getUserInfo() {
            return logreg.getUserInfo();
        }
    },

    watch: {
        showState(val) {
            if (val) {
                document.documentElement.style.overflow = 'hidden';
                this.showWrap = true;
                setTimeout(() => {
                    this.showContent = true;
                }, 10);
            } else {
                document.documentElement.style.overflow = 'auto';
                this.showContent = false;
                setTimeout(() => {
                    this.showWrap = false;
                }, 300);
            }
        }
    },

    created() {
        api.init(this.baseUrl, this.business, this.redirect_uri, this.alias);
    },

    mounted() {
        window.errorMessageLoginTip = window.errorMessageTMX && Object.keys(window.errorMessageTMX);
        logreg.loginAction((state, data) => {
            this.success(data);
        });
    },

    beforeDestroy() {
    }
};
</script>

<style lang="scss">
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        overflow-y: visible;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        overflow-y: visible;
    }
    :-ms-input-placeholder { /* IE 10+ */
        overflow-y: visible;
    }
    :-moz-placeholder { /* Firefox 18- */
        overflow-y: visible;
    }
</style>

<style lang="scss" scoped>
.wrap {
    display: none;
    &.show {
        align-items: center;
        display: -webkit-flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
    }
    .m {
        display: none;
    }
    .bg {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.7;
        top: 0;
        left: 0;
    }
    @media screen and (max-width: 750px) {
       .pc {
            display: none;
        }
        .m {
            display: block;
        }
    }
}
</style>
